<template>
  <div class="ShopIndex">
      <van-tabs>
        <van-tab v-for="(item,index) in district" :key="index" :title="item.name">
          
          内容 {{ index }}
          <div class="Shopbox">
            <ul>
              <li>
                <router-link to="/">
                  <van-image
                    width="50em"
                    height="10em"
                    fit="cover"
                    src="http://gzma.maple.ren/upload/image/20170424/6362862930990916683040185.jpg"
                  />
                  <div class="Shopinfo">
                    <h1>龙韵琴行</h1>                  
                    <van-tag round type="warning">贵阳</van-tag>
                    <p> <i class="iconfont icon-didian"></i>贵阳市新添寨新竹路温泉路口中国人寿保险公司二楼口站台</p>
                    <p>  <i class="iconfont icon-shoujihao"></i> 18285077487</p>
                  </div>
                  </router-link>
                </li>
              <li>
                <router-link to="/">
                  <van-image
                    width="50em"
                    height="10em"
                    fit="cover"
                    src="http://gzma.maple.ren/upload/image/20170424/6362862930990916683040185.jpg"
                  />
                  <div class="Shopinfo">
                    <h1>龙韵琴行</h1>                  
                    <van-tag round type="warning">贵阳</van-tag>
                    <p> <i class="iconfont icon-didian"></i>贵阳市新添寨新竹路温泉路口中国人寿保险公司二楼口站台</p>
                    <p>  <i class="iconfont icon-shoujihao"></i> 18285077487</p>
                  </div>
                  </router-link>
              </li>
              <li>
                <router-link to="/">
                  <van-image
                    width="50em"
                    height="10em"
                    fit="cover"
                    src="http://gzma.maple.ren/upload/image/20170421/6362838100793176197462305.JPG"
                  />
                  <div class="Shopinfo">
                    <h1>龙韵琴行</h1>                  
                    <van-tag round type="warning">贵阳</van-tag>
                    <p> <i class="iconfont icon-didian"></i>贵阳市新添寨新竹路温泉路口中国人寿保险公司二楼口站台</p>
                    <p>  <i class="iconfont icon-shoujihao"></i> 18285077487</p>
                  </div>
                  </router-link>
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
      <footerTabber />
  </div>
</template>

<script>
import footerTabber from '@/components/footerTabber.vue'
export default {
components: {
    footerTabber
  },
  data(){
    return{
      district:[        
        {id:1,name:"贵阳市",ckb:0},
        {id:2,name:"遵义市",ckb:0},
        {id:3,name:"安顺市",ckb:0},
        {id:4,name:"黔南州",ckb:0},
        {id:5,name:"铜仁市",ckb:0},
        {id:6,name:"黔东南州",ckb:0},
        {id:7,name:"毕节市",ckb:0},
        {id:8,name:"六盘水市",ckb:0},
        {id:9,name:"黔西南州",ckb:0},
      ]
    }
  }
}
</script>

<style>
.ShopIndex{padding-bottom: 8vh;}
.Shopbox ul li a{background: #fff;padding: 10px;width: 92%;box-sizing: border-box;margin: 10px auto;display: flex;justify-content: space-between;align-items: center;border-radius: 5px;}
.Shopbox ul li a .Shopinfo{text-align: left;flex: 6.5;}
.Shopbox ul li a .Shopinfo h1{font-weight: bold;margin-bottom: 10px;color: #333;}
.Shopbox ul li a .Shopinfo p{color: #666;line-height: 1.5;font-size: 3.2vw;margin: 10px 0;}
.Shopbox ul li a .Shopinfo p i{font-weight: bold;}
.Shopbox ul li a .van-image{flex: 3.5;margin-right: 2%;}
.Shopbox ul li a .van-image img{border-radius: 5px;}
</style>